import React from "react";import './BlackDotsSpinner.css';

const BlackDotsSpinner = () => {
    return (
        <div className="black-dots-spinner">
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="dot" />
            ))}
        </div>

    );
}
export default BlackDotsSpinner;